import { render, staticRenderFns } from "./AddPersonReport.vue?vue&type=template&id=f413d516&scoped=true&"
import script from "./AddPersonReport.vue?vue&type=script&lang=js&"
export * from "./AddPersonReport.vue?vue&type=script&lang=js&"
import style0 from "./AddPersonReport.vue?vue&type=style&index=0&id=f413d516&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f413d516",
  null
  
)

export default component.exports